document.addEventListener("DOMContentLoaded", function (event) {
    //do work
    document.getElementById('UserName')?.addEventListener('focus', () => {
        document.getElementsByClassName('username-icon')[0].classList.add('active');
    });

    document.getElementById('Email')?.addEventListener('focus', () => {
        document.getElementsByClassName('username-icon')[0].classList.add('active');
    });

    document.getElementById('Password')?.addEventListener('focus', () => {
        document.getElementsByClassName('password-icon')[0].classList.add('active');
    });

    document.getElementById('ConfirmPassword')?.addEventListener('focus', () => {
        document.getElementsByClassName('confirm-password-icon')[0].classList.add('active');
    });

    document.getElementById('UserName')?.addEventListener('blur', () => {
        document.getElementsByClassName('username-icon')[0].classList.remove('active');
    });

    document.getElementById('Email')?.addEventListener('blur', () => {
        document.getElementsByClassName('username-icon')[0].classList.remove('active');
    });

    document.getElementById('Password')?.addEventListener('blur', () => {
        document.getElementsByClassName('password-icon')[0].classList.remove('active');
    });

    document.getElementById('ConfirmPassword')?.addEventListener('blur', () => {
        document.getElementsByClassName('confirm-password-icon')[0].classList.remove('active');
    });
});


// WEBPACK FOOTER //
// ./~/source-map-loader!./Frontend/app/components/login/login.ts